import React, { useState, useEffect } from "react";
import "./Learn.scss";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../../redux-store/store";
import { v4 } from "uuid";
import { HashLink as Anchor } from "react-router-hash-link";

const checkSubscription = (subscribe: []) => {
  return subscribe.filter(
    (el: any) =>
      [
        "Базовый курс + Вместе и навсегда",
        "МАТРИЦА СУДЬБЫ ПРОФИ",
        "РОДОЛОГИЯ В МАТРИЦЕ СУДЬБЫ",
        "ТАРО УЭЙТА",
        "Базовый курс матрицы",
        "Курс детской матрицы",
        "Курс матрицы совместимости",
        "Программа онлайн-курса по Матрице Судьбы с получением диплома государственного образца"
      ].includes(el.subscribe) && el.access === true
  );
};

export const Learn = () => {
  const subscribe = useAppSelector(
    (state) => state.registrationReducer.subscription
  );
  const [set, setState] = useState(false);

  useEffect(() => {
    setState(checkSubscription(subscribe).length > 0);
  }, [subscribe]);

  const learnSubArr = checkSubscription(subscribe);

  const uniqueArray: any[] = [];
  learnSubArr.forEach((item: any) => {
    const existingItem = uniqueArray.find(
      (uniqueItem) =>
        uniqueItem.subscribe === item.subscribe &&
        uniqueItem.access === item.access
    );
    if (!existingItem) {
      uniqueArray.push(item);
    }
  });

  const learnSub = uniqueArray.map((el: any) => {
    const linkUrl = "https://max.ru/u/f9LHodD0cOLJuoBW26WGzDx8oplW__LlVxxfhMB2CdEry19eQ4FEKvJsjfU";

    return (
      <div className={"subLearnSpan"} key={v4()}>
        <span>{el.subscribe}</span>
        <div className={"divLearn"}>
          <Anchor
            className={"batonTarif"}
            smooth
            to={"/learn"}
            style={{ width: "100%" }}
          >
            Посмотреть программу
          </Anchor>
            <a
            className={"batonTarif"}
            href={linkUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ width: "100%", backgroundColor: "rgba(196, 157, 214, 1)", color: "rgba(46, 32, 81, 1)" }}
          >
            Перейти к обучению
          </a>
        </div>
      </div>
    );
  });

  return (
    <div className={"userProfile"}>
          <span className={"spanTarifActive"}>
            Видеообучение
          </span>
      {!set ? (
        <>
          <span className={"spanHistoryNone"}>
            Вы можете приобрести курс по обучению расшифровки матрицы судьбы
          </span>
          <Link
            style={{
              margin: "0",
              backgroundColor: "rgba(196, 157, 214, 1)",
              color: "rgba(46, 32, 81, 1)",
              padding: "10px 50px 10px 50px"
            }}
            className={"batonTarif"}
            to={"/learn"}
          >
            Приобрести обучение
          </Link>
        </>
      ) : (
        <div className={"learnMenu"}>
          {learnSub}
        </div>
      )}
    </div>
  );
};
